import React from "react";
import Arcelia from "../components/about/Arcelia";
import WhoAreWe from "../components/about/WhoAreWe";

import Header from "../components/shared/Header";
import Footer from "../components/shared/Footer";
const About = () => {
    return (
        <>
        <Header pagetitle={"About"} subtitle={"About arcelia"}/>
        <div>
            <Arcelia />
            <WhoAreWe />
        </div>
        <Footer />
        </>
    );
};

export default About;
